import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { graphql } from 'react-relay';

import { isLoggedIn, logout } from '../../security/authentication';
import routeTo from '../utils/routeTo';

import { useAuthenticated_candidate } from './__generated__/useAuthenticated_candidate.graphql';

// eslint-disable-next-line
graphql`
  fragment useAuthenticated_candidate on Candidate {
    id
    name
  }
`;

export const useAuthenticated = (candidate: useAuthenticated_candidate) => {
  const history = useHistory();

  const isAuthenticated = candidate && isLoggedIn();

  const redirectIfNotAuthenticated = () => {
    if (!isAuthenticated) {
      logout();
      history.push(routeTo('auth.login'));
    }
  };

  useEffect(() => {
    redirectIfNotAuthenticated();
  }, [isAuthenticated]);

  return isAuthenticated;
};
